import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import VisibilitySvg from '../../../assets/img/V1/black-eye-icon.svg';
import DownloadSvg from '../../../assets/img/V1/download_icon.svg';

type IActionsProps = {
  handleOpen?: () => void;
  handleDownload?: () => void;
};

function PaymentAction({ handleOpen, handleDownload }: IActionsProps) {
  return (
    <Stack direction="row" justifyContent="center" spacing="2px">
      <IconButton size="small" onClick={handleOpen} aria-label="view-action">
        <Box component="img" src={VisibilitySvg} alt="view icon" />
      </IconButton>
      <IconButton size="small" onClick={handleDownload} aria-label="download-action">
        <Box component="img" src={DownloadSvg} alt="download icon" />
      </IconButton>
    </Stack>
  );
}
export default PaymentAction;
